
import React from "react";
import SwitchToggle from "../../components/SwitchToggle";
import { useNavigate } from "react-router-dom";

const ViewDiscount = () => {
  const navigate=useNavigate();
  return (
    <>
      <div className="main_title">
        <h1>Discount and Coupon Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          <button onClick={() => navigate("/discounts")}>Discounts and Coupons</button> - View Discount and Coupon
        </p>
      </div>

      <div className="cards">
        <div className="view_page">
          <div className="gap_p">
            <div className="w_33">
              <h6>Offer/Discount Name</h6>
              <p>Festival Special Discount</p>
            </div>

            <div className="w_33">
              <h6>Coupon Code</h6>
              <p>
                <span className="status_btn c_success">FESTAUG25</span>
              </p>
            </div>

            <div className="w_33">
              <h6>Discount</h6>
              <p>5%</p>
            </div>

            <div className="w_33">
              <h6>Minimum Sales Required</h6>
              <p>5 Orders</p>
            </div>

            <div className="w_33">
              <h6>Applicable Time</h6>
              <p>Evening (4 PM - 8 PM)</p>
            </div>

            <div className="w_33">
              <h6>Valid From - To</h6>
              <p>25 August 2025 - 30 August 2025</p>
            </div>

            <div className="w_33">
              <h6>Created Date</h6>
              <p>30 July 2025</p>
            </div>

            <div className="w_33">
              <h6>Status</h6>
              <p>
                <SwitchToggle />
              </p>
            </div>

            <div className="w_100">
              <h6>Applicable Products/Categories</h6>
              <ul className="inline_tags">
                <li>Electronics</li>
                <li>Accessories</li>
                <li>Home Decor</li>
              </ul>
            </div>

           
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewDiscount;
